'use client';

import { Disclosure, Transition } from '@headlessui/react';
import ProgressBar from '@ui/ProgressBar';
import Typography from '@ui/Typography';
import { cx } from 'cva';
import React from 'react';

function InKindFundraiserGivingLevels(props) {
  const { post, className, size = 'auto' } = props;
  const { inKindDonations } = post.renderProps;
  const top3Donations = inKindDonations.slice(0, 3);
  const otherDonations = inKindDonations.slice(3);
  const totalDonatedItems = inKindDonations.reduce(
    (acc, curr) => acc + curr.donatedQuantity,
    0,
  );
  const totalItems = inKindDonations.reduce(
    (acc, curr) => acc + curr.quantity,
    0,
  );

  const [showingMore, setShowingMore] = React.useState(false);

  const onShowMore = () => {
    setShowingMore(!showingMore);
  };

  const renderRow = (donation) => (
    <div
      key={donation.id}
      className={cx(
        'flex flex-1 items-end justify-start gap-4',
        size === 'small' && 'flex-col-reverse items-start gap-2',
      )}>
      <div
        className={cx(
          'flex w-full flex-[0.4] flex-col gap-2',
          // size === 'small' ? 'w-full' : 'w-36',
        )}>
        <Typography variant="body2" color="textSecondary">
          {donation.donatedQuantity}/{donation.quantity}
        </Typography>
        <ProgressBar
          value={donation.donatedQuantity}
          max={donation.quantity}
          background="white"
          className="w-full"
        />
      </div>
      <div className="flex w-full flex-[0.6] items-center justify-center rounded-2xl border border-secondary px-3 py-1 text-center">
        <Typography variant="h5" color="secondary">
          {donation.title}
        </Typography>
      </div>
    </div>
  );

  return (
    <div
      className={cx(
        'flex flex-col gap-4 rounded-2xl bg-body-background p-4',
        className,
      )}>
      <div className="flex flex-col gap-4">
        {top3Donations.map((d) => renderRow(d))}

        {otherDonations.length > 0 && (
          <Disclosure>
            {({ open }) => (
              <>
                {!showingMore && (
                  <Disclosure.Button
                    className="flex w-full gap-3"
                    onClick={onShowMore}>
                    <Typography variant="body2" color="primary">
                      + {otherDonations.length} more...
                    </Typography>
                  </Disclosure.Button>
                )}
                <Transition
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0">
                  <Disclosure.Panel className="flex flex-col gap-4">
                    {otherDonations.map((d) => renderRow(d))}
                  </Disclosure.Panel>
                </Transition>
                {showingMore && (
                  <Disclosure.Button
                    className="flex w-full gap-3"
                    onClick={onShowMore}>
                    <Typography variant="body2" color="primary">
                      - show less
                    </Typography>
                  </Disclosure.Button>
                )}
              </>
            )}
          </Disclosure>
        )}
      </div>
      <div className="flex justify-start">
        <div className="flex flex-col">
          <Typography variant="body2" color="textSecondary">
            Total Items Donated
          </Typography>
          <div className="flex items-end">
            <Typography variant="h3" color="textPrimary">
              {totalDonatedItems}
            </Typography>
            <Typography variant="body2" color="textPrimary">
              /{totalItems}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InKindFundraiserGivingLevels;
